import styled from "styled-components";
import { maxSize, textLineClamp } from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";

export const DetailTitle = styled('div')`
    text-align: center;
    ${props => maxSize(76, props.styleType, 'margin-top', 40)};
    ${props => maxSize(48, props.styleType, 'font-size', 24)};

`;

export const DetailSubtitle = styled('div')`
    text-align: center;
    ${props => maxSize(24, props.styleType, 'font-size', 18)};
`;

export const ContentPictureWrapper = styled('div')`
    ${props => maxSize(416, props.styleType, 'margin-left', 84)};
    ${props => maxSize(612, props.styleType, 'width', 275)};
    ${props => maxSize(20, props.styleType, 'margin-top', 16)};

    ${props => {
        if(props.picType === 1) {
            return `
                ${maxSize(411, props.styleType, 'height', 210)};
                border-radius: 6px;
                overflow: hidden;
                & img {
                    height: 100%;
                    width: 100%;
                }
            `
        } else if (props.picType === 4) {
            return `
                ${maxSize(411, props.styleType, 'margin-left', 84)};
                ${maxSize(614.77, props.styleType, 'width', 275)};

                display: flex;
                flex-wrap: wrap;
                & :nth-child(2n+1) {
                    ${maxSize(7, props.styleType, 'margin-right', 3.24)};
                }
                & :nth-child(1), & :nth-child(2) {
                    ${maxSize(8, props.styleType, 'margin-bottom', 4)};
                }
                & div {
                    ${maxSize(303, props.styleType, 'width', 135.88)};
                    position: relative;
                    overflow: hidden;
                    ${maxSize(204, props.styleType, 'height', 91.25)};
                    & img {
                        height: 100%;
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                        right: 50%;
                    }
                }
            `
        } else if (props.picType === 5) {
            return `
                ${maxSize(491, props.styleType, 'height', 210)};
            `;
        }
    }}

`;

export const ContentSubtitle = styled('div')`
    ${props => maxSize(40, props.styleType, 'margin-top', 16)};
    ${props => maxSize(416, props.styleType, 'margin-left', 84)};
    ${props => maxSize(24, props.styleType, 'font-size', 14)};
    ${props => maxSize(10000, props.styleType, 'max-width', 214)};
    ${textLineClamp(2)};
`;

export const ContentMain = styled('pre')`
    white-space: pre-wrap;
    color: #A38F8F;
    letter-spacing: 0.06em;   
    ${props => {
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
                margin: auto;
            `
        } else {
            return `
                ${maxSize(0, props.styleType, 'margin-left', 84)};   
            `
        }
    }}
    ${props => maxSize(20, props.styleType, 'margin-top', 16)};
    ${props => maxSize(16, props.styleType, 'font-size', 10)};
    ${props => maxSize(32, props.styleType, 'line-height', 24)};
    ${props => maxSize(612, props.styleType, 'width', 275)};
`;

export const DetailCatelogWrapper = styled('div')`
    ${props => {
        if(props.needFixed) {
            return `
                position: fixed;
                ${maxSize(253, props.styleType, 'top', 114)};
                ${maxSize(140, props.styleType, 'left', 16)};
        `
        } else {
            return `
                position: absolute;
                ${maxSize(806, props.styleType, 'top', 531)};
                ${maxSize(140, props.styleType, 'left', 16)};
            `
        }
    }}

`;

export const DetailItems = styled('a')`
    display: block;
    ${props => maxSize(props.highlight ? 72 : 47, props.styleType, 'width', props.highlight ? 36 : 24)};
    ${props => maxSize(16, props.styleType, 'padding-top', 8)};
    ${props => maxSize(16, props.styleType, 'margin-bottom', 8)};
    ${props => maxSize(14, props.styleType, 'font-size', 9)};
    border-top: 1px solid ${props => props.highlight ? 'black' : themeColor};
    color: ${props => props.highlight ? 'black' : themeColor};
    white-space: nowrap;
    
`;

export const ContentBlockWrapper = styled('div')`
    ${props => maxSize(40, props.styleType, 'margin-top', 24)};
`;

export const ReserveButton = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                background: #B69A67;
                text-align: center;
                color: #FFFFFF;
                ${maxSize(8, props.styleType, 'border-radius', 10)};
                ${maxSize(8, props.styleType, 'margin-top', 11)};
                ${maxSize(8, props.styleType, 'margin-left', -8)};
                ${maxSize(8, props.styleType, 'font-size', 8)};
                ${maxSize(60, props.styleType, 'width', 60)};
                ${maxSize(20, props.styleType, 'height', 20)};
                line-height: 6vw;
            `
        } else {
            return `
                position: fixed;
                z-index:3;
                ${maxSize(0, props.styleType, 'bottom', 0.1)};
                ${maxSize(0, props.styleType, 'right', 0)};
                ${maxSize(253, props.styleType, 'width', 375)};
                ${maxSize(68, props.styleType, 'height', 48)};
                background-color: ${themeColor};
                color: white;
                ${maxSize(20, props.styleType, 'font-size', 16)};
                display: flex;
                justify-content: center;
                align-items: center;
            `
        }
    }}
`

export const ReserveIntroWrapper = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                ${maxSize(612, props.styleType, 'width', 375)};
                ${maxSize(100, props.styleType, 'height', 67)};
                position: relative;
                background-color: ${themeColor};
                ${maxSize(24, props.styleType, 'margin-top', 40)};
            `
        } else {
            return `
                ${maxSize(612, props.styleType, 'width')};
                ${maxSize(100, props.styleType, 'height', 68)};
                background-color: ${themeColor};
                display: flex;
                justify-content: center;
                align-items: center;
                margin: auto;
                position: relative;
                ${maxSize(24, props.styleType, 'margin-top', 68)};
            `
        }
    } 
    }

`;

export const ReserveText = styled('div')`
    ${
        props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return `
                    ${maxSize(14, props.styleType, 'font-size', 10)};
                    ${maxSize(256, props.styleType, 'width', 192)};
                    overflow: hidden;
                    text-overflow: ellipsis;
                    position: absolute;
                    top: 50%;
                    transform: translate(0, -50%);
                    ${maxSize(24, props.styleType, 'left', 24)};
                    color: white;
                `
            } else {
                return `
                    ${maxSize(256, props.styleType, 'width')};
                    ${maxSize(52, props.styleType, 'height', 68)};
                    ${maxSize(56, props.styleType, 'line-height', 68)};
                    ${maxSize(11, props.styleType, 'margin-right', 68)};
                    background: #F8F5F1;
                    border: 1px solid #434A53;
                    color: #393939;
                    border-radius: 4px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                    ${maxSize(14, props.styleType, 'font-size', 68)};
                `
            }
        }
    }

`;

export const ReseveIntroButton = styled('div')`
    ${
        props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return `
                    position: absolute;
                    ${maxSize(21, props.styleType, 'top', 13)};
                    ${maxSize(24, props.styleType, 'right', 25)};
                `
            }
        }
    }
    ${props => maxSize(129, props.styleType, 'width', 129)};
    ${props => maxSize(52, props.styleType, 'height', 39)};
    ${props => maxSize(56, props.styleType, 'line-height', 44)};
    ${props => maxSize(18, props.styleType, 'font-size', 14)};
    ${props => maxSize(11, props.styleType, 'margin-right', 0.1)};
    color: black;
    text-decoration:none;
    background: #F8F5F1;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.16);
    border-radius: 26px;
    text-align: center;
`;

export const IntroText = styled('div')`
    ${
        props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return 'display: none;';
            }
        }
    }
    color: white;
    ${props => maxSize(18, props.styleType, 'font-size', 68)};
`;

export const TeleWrapper = styled('div')`
    ${
        props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return `
                    position: absolute;
                    ${maxSize(18, props.styleType, 'font-size', 10)};
                    ${maxSize(40, props.styleType, 'top', 37)};
                    ${maxSize(24, props.styleType, 'margin-left', 24)};
                    color: white;
                `;
            } else {
                return `
                    position: absolute;
                    ${maxSize(-50, props.styleType, 'bottom', 40)};
                    ${maxSize(18, props.styleType, 'font-size', 68)};
                    ${maxSize(612, props.styleType, 'width')};
                    text-align: center;
                    color: black;
                    left:0;
                `;  
            }
        }
    }
    ${props => maxSize(18, props.styleType, 'font-size', 10)};
`;

export const TelephoneWrapper = styled('span')`
    ${props => maxSize(18, props.styleType, 'font-size', 10)};

`;

export const TimeWrapper = styled('span')`
    ${props => maxSize(18, props.styleType, 'font-size', 8)};

`;

export const IntroInfo = styled('div')`
    margin: auto;
    color: #A38F8F;
    letter-spacing: 0.06em;
    ${props => maxSize(14, props.styleType, 'margin-top', 8)};
    ${props => textLineClamp(props.styleType === STYLE_TYPE.MOBILE ? 2 : 3)};
    ${props => maxSize(398, props.styleType, 'width', 297)};
    ${props => maxSize(90, props.styleType, 'height', 40)};
    ${props => maxSize(32, props.styleType, 'line-height', 20)};
    ${props => maxSize(16, props.styleType, 'font-size', 10)};
`;

export const MapWrapper = styled('div')`
    position: relative;
    ${props => {
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
                margin: auto;
            `
        } else {
            return `
                ${maxSize(0, props.styleType, 'margin-left', 84)};   
            `
        }
    }}
    ${props => maxSize(20, props.styleType, 'margin-top', 20)};
    ${props => maxSize(612, props.styleType, 'width', 265)};
    ${props => maxSize(495, props.styleType, 'height', 247)};
    & #map_container {
        width: 100%;
        height: 100%;
    }
`;

export const MapIntro = styled('div')`
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    color: white;
    z-index: 2;
    ${props => maxSize(24, props.styleType, 'font-size', 14)};
    ${props => maxSize(52, props.styleType, 'height', 29)};
    ${props => maxSize(60, props.styleType, 'line-height', 32)};
    background: rgba(0, 0, 0, 0.5);
    & span {
        display: inline-block;
        ${props => maxSize(24, props.styleType, 'margin-left', 8)};
    }
`;

export const ReturnButton = styled('div')`
    background: #DFDFDF;
    color: #979797;
    border-radius: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${props => maxSize(20, props.styleType, 'font-size', 12)};
    ${props => maxSize(201, props.styleType, 'width', 95)};
    ${props => maxSize(68, props.styleType, 'height', 34)};
    ${props => maxSize(12, props.styleType, 'margin-right', 18)};
`;

export const PlanButtonWrapper = styled('div')`
    display: flex;
    ${props => maxSize(465, props.styleType, 'margin-left', 84)};
    ${props => maxSize(40, props.styleType, 'margin-top', 27)};
    
`;

export const ToReserveButton = styled('div')`
    background: ${themeColor};
    color: #FFFFFF;
    border-radius: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${props => maxSize(20, props.styleType, 'font-size', 12)};
    ${props => maxSize(305, props.styleType, 'width', 157)};
    ${props => maxSize(68, props.styleType, 'height', 34)};
`;

export const OverviewWrapper = styled('pre')`
white-space: pre-wrap;
color: #A38F8F;
letter-spacing: 0.06em;   
${props => {
    if(props.styleType !== STYLE_TYPE.MOBILE) {
        return `
            margin: auto;
        `
    } else {
        return `
            ${maxSize(0, props.styleType, 'margin-left', 84)};   
        `
    }
}}
${props => maxSize(20, props.styleType, 'margin-top', 16)};
${props => maxSize(16, props.styleType, 'font-size', 10)};
${props => maxSize(32, props.styleType, 'line-height', 24)};
${props => maxSize(612, props.styleType, 'width', 275)};
`;

export const OverviewPicture = styled('pre')`
white-space: pre-wrap;
color: #A38F8F;
letter-spacing: 0.06em;   
${props => {
    if(props.styleType !== STYLE_TYPE.MOBILE) {
        return `
            margin: auto;
        `
    } else {
        return `
            ${maxSize(0, props.styleType, 'margin-left', 84)};   
        `
    }
}}
${props => maxSize(20, props.styleType, 'margin-top', 16)};
${props => maxSize(16, props.styleType, 'font-size', 10)};
${props => maxSize(32, props.styleType, 'line-height', 24)};
${props => maxSize(612, props.styleType, 'width', 275)};
`;